import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {Button, Table, message, Form, Modal, Spin, Space, Row, Col, Tag, Tooltip, Input, Card, Typography, Avatar, Divider} from 'antd';
import CustomModal from '../../components/common/CustomModal';
import {Link, useNavigate} from "react-router-dom";
import {MdAddHome} from "react-icons/md";
import {UserAddOutlined, UserDeleteOutlined, SearchOutlined, EyeOutlined, UserOutlined, MailOutlined, PhoneOutlined, HomeOutlined, IdcardOutlined} from '@ant-design/icons';
import {
    AiFillDelete,
    AiFillEdit,
} from "react-icons/ai";
import {IoReload} from "react-icons/io5";
import Search from "antd/es/input/Search";
import _ from "lodash";



export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS
});

// const { Option } = Select;


const Persona = () => {

    if(sessionStorage.getItem('user_mod'))
       sessionStorage.removeItem('user_mod');

    let info_user = JSON.parse(sessionStorage.getItem('info_user'));

    const [bottom, setBottom] = useState('bottomCenter');

    const [original, setOriginal] = useState([]);
    const [data, setData] = useState([]);

    const [form] = Form.useForm();
    const [formSearch] = Form.useForm();

    const navigate = useNavigate();

    const [spinning, setSpinning] = useState(false);
    const [spinTitle, setSpinTitle] = useState("Cargando datos...");

    const [messageApi, contextHolder] = message.useMessage();

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading/*, setLoading*/] = useState(false);

    const [selectedRow, setSelectedRow] = useState([]); // Estado para la fila seleccionada
    const [isVerVisible, setIsVerVisible] = useState(false); // Estado del modal

    const [searchCIPasaporteValue, setSearchCIPasaporte] = useState(''); // Estado para controlar el valor del input
    const [searchDireccionValue, setSearchDireccion] = useState(''); // Estado para controlar el valor del input

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: data.length, // Asegúrate de tener el total de elementos aquí
    });

    const handleTableChange = (newPagination) => {
        setPagination({
            ...pagination,
            current: newPagination.current,
            pageSize: newPagination.pageSize,
        });
    };

    const headers = {
        'accept': '*/*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      };

    useEffect(() => {
        recargar();
    }, []);

    const filterData = data => formatter => data.map( item => ({
        text: formatter(item),
        value: formatter(item)
    }));

    const columns = [
        {
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>Nombre</p>,
            dataIndex: 'nombre',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.nombre), _.isEqual),
            onFilter: (value, record) => record.nombre.startsWith(value),
        },
        {
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>Primer Apellido</p>,
            dataIndex: 'papell',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.papell), _.isEqual),
            onFilter: (value, record) => record.papell.startsWith(value),
        },{
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>Segundo Apellido</p>,
            dataIndex: 'sapell',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.sapell), _.isEqual),
            onFilter: (value, record) => record.sapell.startsWith(value),
        },{
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>CI / Pasaporte</p>,
            dataIndex: 'carnet',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.carnet), _.isEqual),
            onFilter: (value, record) => record.carnet.startsWith(value),
        },{
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>Teléfono</p>,
            dataIndex: 'telefono',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.telefono), _.isEqual),
            onFilter: (value, record) => record.telefono.startsWith(value),
        }
    ];

    const recargar = () => {
        setSearchCIPasaporte(''); // Resetea el valor del campo de búsqueda
        setSearchDireccion(''); // Resetea el valor del campo de búsqueda

        setSpinTitle("Cargando datos...");
        setSpinning(true);
        setSelectedRowKeys([]);
        let aux = [];

        let start = 0;
        let limit = 1000;

        Axios.post("sd/getPersonas",
            {
                // "start": start,
                // "limit": limit,
                // "filtro":{
                //     "idrol": 1
                // }
            },
            {
                headers: headers
            }
        ).then(response => {
            setSpinning(false);
            if(response.data.data.length>0){
                for(let i=0;i<response.data.data.length;i++){
                    aux.push({
                        key:response.data.data[i].idpersona,
                        idpersona:response.data.data[i].idpersona,
                        nombre:response.data.data[i].nombre,
                        papell:response.data.data[i].papell,
                        sapell:response.data.data[i].sapell,
                        carnet:response.data.data[i].carnet,
                        telefono:response.data.data[i].telefono,
                        direccion:response.data.data[i].direccion,
                        correo:response.data.data[i].correo,
                    });
                }
            }

            setData(aux);
            setOriginal(aux);
        }).catch(error => {
            setSpinning(false);
        });

    };

    const getInfoForm = async (id) => {
        for(let i=0; i < data.length; i++){
            if(data[i].idpersona === id){
                return data[i];
            }
        }
        return [];
    };

    const modificar = async () => {
        form.resetFields();
        const row = await getInfoForm(selectedRowKeys[0]);
        // console.log(selectedRowKeys[0])
        sessionStorage.setItem('user_mod', JSON.stringify(row));
    };

    const eliminar = (e) => {
        Modal.confirm({
            title: null,
            cancelText:'Cancelar',
            okText:'Aceptar',
            okType:'primary',
            content: (
                <div>
                    <div style={{
                        background: 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)',
                        borderRadius: '12px 12px 0 0',
                        padding: '24px',
                        color: 'white',
                        textAlign: 'center',
                        marginBottom: '20px'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '16px'
                        }}>
                            <div style={{
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                width: '48px',
                                height: '48px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '20px'
                            }}>
                                <UserDeleteOutlined />
                            </div>
                            <div>
                                <Typography.Title level={3} style={{
                                    color: 'white',
                                    margin: 0,
                                    fontSize: '20px'
                                }}>
                                    Eliminar datos!
                                </Typography.Title>
                            </div>
                        </div>
                    </div>
                    <div style={{ padding: '0 24px' }}>
                        <span>¿Desea eliminar los datos seleccionados?</span>
                    </div>
                </div>
            ),
            onOk() {
                setSpinTitle("Eliminando datos...");
                setSpinning(true);
                Axios.post("sd/eliminarPersona",
                    {
                        "idpersona": selectedRowKeys,
                        "nombreusuario": info_user.nombreusuario
                    },
                    {
                        headers: headers
                    }
                ).then(response => {
                    setSpinning(false);
                    if(response.data.success){
                        messageApi.open({
                            type: 'success',
                            content: response.data.message,
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);
                        recargar();
                    }else{
                        messageApi.open({
                            type: 'error',
                            content: response.data.message,
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);
                    }
                })
                    .catch(error => {
                        setSpinning(false);
                        messageApi.open({
                            type: 'error',
                            content: 'Error al guardar los datos',
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);

                    });
            },
        });
    };

    const onSearch = (value, _e, info) => {
        filterLocal(value);
    };

    const filterLocal = (value) => {
        if(value === "" || value === null){
            setData(original);
        }else{
            let aux = [];
            original.forEach(function(option) {
                if (option.carnet.toUpperCase().indexOf(value.toUpperCase()) !== -1) {
                    aux.push(option);
                }
            });
            setData(aux);
        }
    };
    const onSearchDireccion = (value, _e, info) => {
        filterLocal(value);
    };
    const filterLocalDireccion = (value) => {
        if(value === "" || value === null){
            setData(original);
        }else{
            let aux = [];
            original.forEach(function(option) {
                if (option.direccion.toUpperCase().indexOf(value.toUpperCase()) !== -1) {
                    aux.push(option);
                }
            });
            setData(aux);
        }
    };


    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;

    const selectRowUpdate  = async (record) => {
        setSelectedRowKeys([record.key]);
        form.resetFields();
        let row = [];
        for(let i=0;i<data.length;i++){
            if(data[i].idpersona === record.key){
                row = data[i];
            }
        }

        sessionStorage.setItem('user_mod', JSON.stringify(row));
        navigate(`/edittipotransporte/${record.key}`)

    };
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [searchParams, setSearchParams] = useState({});

    const showModal = () => {
        formSearch.resetFields();
        setIsModalVisible(true);
    };

    const handleFormChange = (changedValues, allValues) => {
        allValues = {"filtros":
                        {
                            nombre: allValues.nombre,
                            papell: allValues.papell,
                            sapell: allValues.sapell,
                            carnet: allValues.carnet,
                            telefono: allValues.telefono,
                            direccion: allValues.direccion,
                            correo: allValues.correo
                        }
                    };
        //console.log(allValues);
        setSearchParams(allValues);  // Actualizar los parámetros de búsqueda conforme se llena el formulario
    };

    const handleOk = () => {
        setSpinTitle("Buscando...");
        setSpinning(true);
        Axios.post('sd/getPersonas', searchParams, { headers })  // Se envían los parámetros de búsqueda
            .then(response => {
                setSpinning(false);
                if (response.data.data.length > 0) {
                    const aux = response.data.data.map(persona => ({
                        key: persona.idpersona,
                        idpersona: persona.idpersona,
                        nombre: persona.nombre,
                        papell: persona.papell,
                        sapell: persona.sapell,
                        carnet: persona.carnet,
                        telefono: persona.telefono,
                        direccion: persona.direccion,
                        correo: persona.correo
                    }));
                    setData(aux);  // Actualizar la tabla con los resultados de búsqueda
                } else {
                    message.warning('No se encontraron resultados.');
                    setData([]);
                }
                setIsModalVisible(false);  // Cerrar el modal después de realizar la búsqueda
            })
            .catch(() => {
                setSpinning(false);
                message.error('Error al realizar la búsqueda.');
            });
    };


    const handleCancel = () => {
        formSearch.resetFields();
        setIsModalVisible(false);
    };

    const showModalVer = async () => {
        const row = await getInfoForm(selectedRowKeys[0]);
        setSelectedRow(row); // Guardar la fila seleccionada
        setIsVerVisible(true); // Mostrar el modal
    };

    const handleCancelVer = () => {
        setIsVerVisible(false); // Ocultar el modal
    };


    return (
        <div style={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: "16px"
        }}>
            <Spin spinning={spinning} tip={spinTitle} size={"large"}>
                {/* Header Principal */}
                <div style={{
                    background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                    borderRadius: '8px',
                    padding: '12px',
                    marginBottom: '12px',
                    color: 'white',
                    boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                }}>
                    <Row align="middle">
                        <Col xs={24} md={16}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <UserOutlined style={{ fontSize: '24px' }} />
                                <div>
                                    <Typography.Title level={4} style={{ color: 'white', margin: 0, marginBottom: '2px' }}>
                                        Personas
                                    </Typography.Title>
                                    <Typography.Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px' }}>
                                        Gestión del sistema
                                    </Typography.Text>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} md={8} style={{ textAlign: 'right' }}>
                            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', alignItems: 'center', flexWrap: 'wrap' }}>
                                <div style={{
                                    background: 'rgba(255,255,255,0.15)',
                                    borderRadius: '4px',
                                    padding: '2px 6px',
                                    backdropFilter: 'blur(10px)'
                                }}>
                                    <Typography.Text style={{ color: 'white', fontSize: '10px' }}>
                                        Total: {data.length}
                                    </Typography.Text>
                                </div>
                                <div style={{
                                    background: 'rgba(255,255,255,0.2)',
                                    borderRadius: '4px',
                                    padding: '4px 6px',
                                    backdropFilter: 'blur(10px)'
                                }}>
                                    <Typography.Text style={{ color: 'white', fontSize: '10px' }}>
                                        Selec: {selectedRowKeys.length}
                                    </Typography.Text>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>

                {contextHolder}
                {/* Panel de Acciones */}
                <Card
                    style={{
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: 'none',
                        marginBottom: '12px'
                    }}
                    styles={{ body: { padding: '12px' } }}
                >
                    <Row justify="center" align="middle">
                        <Col xs={24}>
                            <Space wrap size="small" style={{ justifyContent: 'center', width: '100%' }}>
                                <Link to="/addpersona">
                                    <Tooltip title="Adicionar">
                                        <Button
                                            type="primary"
                                            icon={<UserAddOutlined/>}
                                            disabled={loading}
                                            size="small"
                                            style={{
                                                background: loading
                                                    ? '#d9d9d9'
                                                    : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                                borderColor: loading
                                                    ? '#d9d9d9'
                                                    : '#253289',
                                                color: loading
                                                    ? '#000000'
                                                    : 'white',
                                                borderRadius: '6px',
                                                fontWeight: '500',
                                                boxShadow: loading
                                                    ? 'none'
                                                    : '0 2px 8px rgba(37, 50, 137, 0.3)'
                                            }}
                                        >
                                            Adicionar
                                        </Button>
                                    </Tooltip>
                                </Link>

                                <Link to={`/editpersona/${selectedRowKeys[0]}`}>
                                    <Tooltip title="Modificar">
                                        <Button
                                            type="primary"
                                            icon={<AiFillEdit/>}
                                            onClick={modificar}
                                            disabled={loading || selectedRowKeys.length !== 1}
                                            size="small"
                                            style={{
                                                background: (loading || selectedRowKeys.length !== 1)
                                                    ? '#d9d9d9'
                                                    : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                                borderColor: (loading || selectedRowKeys.length !== 1)
                                                    ? '#d9d9d9'
                                                    : '#253289',
                                                color: (loading || selectedRowKeys.length !== 1)
                                                    ? '#000000'
                                                    : 'white',
                                                borderRadius: '6px',
                                                fontWeight: '500',
                                                boxShadow: (loading || selectedRowKeys.length !== 1)
                                                    ? 'none'
                                                    : '0 2px 8px rgba(37, 50, 137, 0.3)'
                                            }}
                                        >
                                            Editar
                                        </Button>
                                    </Tooltip>
                                </Link>

                                <Tooltip title="Ver detalles">
                                    <Button
                                        type="default"
                                        icon={<EyeOutlined/>}
                                        onClick={showModalVer}
                                        disabled={!hasSelected || loading || selectedRowKeys.length !== 1}
                                        size="small"
                                        style={{
                                            borderColor: (!hasSelected || loading || selectedRowKeys.length !== 1)
                                                ? '#d9d9d9'
                                                : '#253289',
                                            color: (!hasSelected || loading || selectedRowKeys.length !== 1)
                                                ? '#000000'
                                                : '#253289',
                                            borderRadius: '6px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Ver
                                    </Button>
                                </Tooltip>

                                <Tooltip title="Eliminar">
                                    <Button
                                        danger
                                        type="primary"
                                        icon={<UserDeleteOutlined/>}
                                        onClick={eliminar}
                                        disabled={!hasSelected || loading}
                                        size="small"
                                        style={{
                                            borderRadius: '6px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Eliminar
                                    </Button>
                                </Tooltip>

                                <Tooltip title="Buscar Personas">
                                    <Button
                                        type="default"
                                        icon={<SearchOutlined/>}
                                        onClick={showModal}
                                        size="small"
                                        style={{
                                            borderColor: '#253289',
                                            color: '#253289',
                                            borderRadius: '6px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Buscar
                                    </Button>
                                </Tooltip>

                                <Tooltip title="Actualizar">
                                    <Button
                                        type="default"
                                        icon={<IoReload/>}
                                        onClick={recargar}
                                        loading={loading}
                                        size="small"
                                        style={{
                                            borderColor: loading
                                                ? '#d9d9d9'
                                                : '#253289',
                                            color: loading
                                                ? '#000000'
                                                : '#253289',
                                            borderRadius: '6px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Recargar
                                    </Button>
                                </Tooltip>
                            </Space>
                        </Col>
                    </Row>
                </Card>

                    <CustomModal
                        open={isModalVisible}
                        onCancel={handleCancel}
                        title="Búsqueda Avanzada de Personas"
                        subtitle="Complete los campos para filtrar los resultados"
                        icon={<SearchOutlined />}
                        width={800}
                        centered={false}
                        style={{ top: 20 }}
                    >
                                <Form form={formSearch} layout="vertical" onValuesChange={handleFormChange}>
                                    {/* Sección de Datos Personales */}
                                    <div style={{
                                        background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                        borderRadius: '12px',
                                        padding: '20px',
                                        marginBottom: '20px',
                                        border: '1px solid #e0e6ff'
                                    }}>
                                        <Typography.Title level={5} style={{ color: '#253289', marginBottom: '16px' }}>
                                            <UserOutlined style={{ marginRight: '8px' }} />
                                            Datos Personales
                                        </Typography.Title>

                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#253289', fontWeight: '500' }}>Nombre</span>}
                                                    name="nombre"
                                                >
                                                    <Input
                                                        prefix={<UserOutlined style={{ color: '#253289' }} />}
                                                        placeholder="Ingrese el nombre"
                                                        style={{ borderRadius: '6px' }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#253289', fontWeight: '500' }}>Primer Apellido</span>}
                                                    name="papell"
                                                >
                                                    <Input
                                                        prefix={<UserOutlined style={{ color: '#253289' }} />}
                                                        placeholder="Ingrese el primer apellido"
                                                        style={{ borderRadius: '6px' }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#253289', fontWeight: '500' }}>Segundo Apellido</span>}
                                                    name="sapell"
                                                >
                                                    <Input
                                                        prefix={<UserOutlined style={{ color: '#253289' }} />}
                                                        placeholder="Ingrese el segundo apellido"
                                                        style={{ borderRadius: '6px' }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#253289', fontWeight: '500' }}>CI / Pasaporte</span>}
                                                    name="carnet"
                                                >
                                                    <Input
                                                        prefix={<IdcardOutlined style={{ color: '#253289' }} />}
                                                        placeholder="Ingrese el CI o Pasaporte"
                                                        style={{ borderRadius: '6px' }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Sección de Contacto */}
                                    <div style={{
                                        background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                        borderRadius: '12px',
                                        padding: '20px',
                                        marginBottom: '20px',
                                        border: '1px solid #e0e6ff'
                                    }}>
                                        <Typography.Title level={5} style={{ color: '#253289', marginBottom: '16px' }}>
                                            <MailOutlined style={{ marginRight: '8px' }} />
                                            Información de Contacto
                                        </Typography.Title>

                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#253289', fontWeight: '500' }}>Correo</span>}
                                                    name="correo"
                                                >
                                                    <Input
                                                        prefix={<MailOutlined style={{ color: '#253289' }} />}
                                                        placeholder="ejemplo@correo.com"
                                                        style={{ borderRadius: '6px' }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#253289', fontWeight: '500' }}>Teléfono</span>}
                                                    name="telefono"
                                                >
                                                    <Input
                                                        prefix={<PhoneOutlined style={{ color: '#253289' }} />}
                                                        placeholder="Ingrese el teléfono"
                                                        style={{ borderRadius: '6px' }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Form.Item
                                            label={<span style={{ color: '#253289', fontWeight: '500' }}>Dirección</span>}
                                            name="direccion"
                                        >
                                            <Input
                                                prefix={<HomeOutlined style={{ color: '#253289' }} />}
                                                placeholder="Ingrese la dirección"
                                                style={{ borderRadius: '6px' }}
                                            />
                                        </Form.Item>
                                    </div>

                                    {/* Footer con botones */}
                                    <div style={{
                                        background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                        borderRadius: '12px',
                                        padding: '20px',
                                        textAlign: 'center',
                                        border: '1px solid #e0e6ff'
                                    }}>
                                        <Space size="large">
                                            <Button
                                                onClick={handleCancel}
                                                size="large"
                                                style={{
                                                    borderRadius: '8px',
                                                    minWidth: '120px',
                                                    height: '44px',
                                                    fontWeight: '500'
                                                }}
                                            >
                                                Cancelar
                                            </Button>
                                            <Button
                                                type="primary"
                                                onClick={handleOk}
                                                size="large"
                                                style={{
                                                    background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                                    borderColor: '#253289',
                                                    borderRadius: '8px',
                                                    minWidth: '120px',
                                                    height: '44px',
                                                    fontWeight: '500',
                                                    boxShadow: '0 4px 12px rgba(37, 50, 137, 0.3)'
                                                }}
                                            >
                                                Buscar
                                            </Button>
                                        </Space>
                                    </div>
                                </Form>
                    </CustomModal>

                    <CustomModal
                        open={isVerVisible}
                        onCancel={handleCancelVer}
                        title={selectedRow ? `${selectedRow.nombre} ${selectedRow.papell}` : ""}
                        subtitle={selectedRow ? selectedRow.sapell : ""}
                        icon={<UserOutlined />}
                        width={1000}
                        centered={false}
                        style={{ top: 20 }}
                    >
                        {selectedRow && (
                            <div>
                                <Row gutter={[24, 16]}>
                                        {/* Información Personal */}
                                        <Col xs={24} md={12}>
                                            <Card
                                                size="small"
                                                title={
                                                    <span style={{ color: '#253289', fontWeight: 'bold' }}>
                                                        <UserOutlined style={{ marginRight: '8px' }} />
                                                        Información Personal
                                                    </span>
                                                }
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #e0e6ff',
                                                    background: '#fafbff'
                                                }}
                                            >
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        <UserOutlined style={{ color: '#253289', fontSize: '16px' }} />
                                                        <Typography.Text strong style={{ color: '#253289', minWidth: 'fit-content' }}>Nombre completo:</Typography.Text>
                                                        <Typography.Text style={{ flex: 1 }}>{selectedRow.nombre} {selectedRow.papell} {selectedRow.sapell}</Typography.Text>
                                                    </div>
                                                    <Divider style={{ margin: '4px 0' }} />
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        <IdcardOutlined style={{ color: '#253289', fontSize: '16px' }} />
                                                        <Typography.Text strong style={{ color: '#253289', minWidth: 'fit-content' }}>CI/Pasaporte:</Typography.Text>
                                                        <Typography.Text copyable style={{ flex: 1 }}>{selectedRow.carnet}</Typography.Text>
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>

                                        {/* Información de Contacto */}
                                        <Col xs={24} md={12}>
                                            <Card
                                                size="small"
                                                title={
                                                    <span style={{ color: '#253289', fontWeight: 'bold' }}>
                                                        <MailOutlined style={{ marginRight: '8px' }} />
                                                        Información de Contacto
                                                    </span>
                                                }
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #e0e6ff',
                                                    background: '#fafbff'
                                                }}
                                            >
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        <MailOutlined style={{ color: '#253289', fontSize: '16px' }} />
                                                        <Typography.Text strong style={{ color: '#253289', minWidth: 'fit-content' }}>Correo:</Typography.Text>
                                                        <Typography.Text copyable style={{ flex: 1 }}>{selectedRow.correo || 'No especificado'}</Typography.Text>
                                                    </div>
                                                    <Divider style={{ margin: '4px 0' }} />
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        <PhoneOutlined style={{ color: '#253289', fontSize: '16px' }} />
                                                        <Typography.Text strong style={{ color: '#253289', minWidth: 'fit-content' }}>Teléfono:</Typography.Text>
                                                        <Typography.Text copyable style={{ flex: 1 }}>{selectedRow.telefono}</Typography.Text>
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>

                                        {/* Dirección */}
                                        <Col xs={24}>
                                            <Card
                                                size="small"
                                                title={
                                                    <span style={{ color: '#253289', fontWeight: 'bold' }}>
                                                        <HomeOutlined style={{ marginRight: '8px' }} />
                                                        Dirección
                                                    </span>
                                                }
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #e0e6ff',
                                                    background: '#fafbff'
                                                }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                    <HomeOutlined style={{ color: '#253289', fontSize: '16px' }} />
                                                    <Typography.Text strong style={{ color: '#253289', minWidth: 'fit-content' }}>Dirección completa:</Typography.Text>
                                                    <Typography.Text style={{ flex: 1 }}>{selectedRow.direccion}</Typography.Text>
                                                </div>
                                            </Card>
                                        </Col>
                                    </Row>

                                    {/* Footer con botón */}
                                    <div style={{
                                        marginTop: '24px',
                                        textAlign: 'center',
                                        padding: '16px',
                                        background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                        borderRadius: '8px',
                                        border: '1px solid #e0e6ff'
                                    }}>
                                        <Button
                                            type="primary"
                                            onClick={handleCancelVer}
                                            size="large"
                                            style={{
                                                background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                                borderColor: '#253289',
                                                borderRadius: '8px',
                                                minWidth: '120px',
                                                height: '44px',
                                                fontWeight: '500',
                                                boxShadow: '0 4px 12px rgba(37, 50, 137, 0.3)'
                                            }}
                                        >
                                            Cerrar
                                        </Button>
                                    </div>
                                </div>
                        )}
                    </CustomModal>

                {/* Tabla de Personas */}
                <Card
                    style={{
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: 'none'
                    }}
                    styles={{ body: { padding: '0' } }}
                    title={
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '12px 16px',
                            borderBottom: '1px solid #f0f0f0'
                        }}>
                            <Typography.Title level={5} style={{ margin: 0, color: '#253289' }}>
                                Lista de Personas
                            </Typography.Title>
                            <Space size="small">
                                <Input
                                    placeholder="CI / Pasaporte"
                                    style={{ width: '160px' }}
                                    size="small"
                                    value={searchCIPasaporteValue}
                                    onChange={(e) => {
                                        setSearchCIPasaporte(e.target.value);
                                        filterLocal(e.target.value);
                                    }}
                                    allowClear
                                />
                                <Input
                                    placeholder="Dirección"
                                    style={{ width: '160px' }}
                                    size="small"
                                    value={searchDireccionValue}
                                    onChange={(e) => {
                                        setSearchDireccion(e.target.value);
                                        filterLocalDireccion(e.target.value);
                                    }}
                                    allowClear
                                />
                            </Space>
                        </div>
                    }
                >
                    <Table
                        size="small"
                        pagination={{
                            position: ['bottomCenter'],
                            current: pagination.current,
                            pageSize: pagination.pageSize,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            showTotal: (total) => `Total ${total} elementos`,
                            style: { padding: '8px' }
                        }}
                        rowSelection={rowSelection}
                        columns={columns}
                        dataSource={data}
                        onChange={handleTableChange}
                        style={{
                            background: 'white',
                            borderRadius: '8px'
                        }}
                        onRow={() => {
                            return {
                                onDoubleClick: async () => {
                                    //selectRowUpdate(record);
                                }
                            }
                        }}
                        expandable={{
                            expandedRowRender: (record) => (
                                <div style={{
                                    background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                    borderRadius: '6px',
                                    padding: '12px',
                                    margin: '4px 0',
                                    border: '1px solid #e0e6ff'
                                }}>
                                    <Row gutter={[16, 8]}>
                                        <Col xs={24} sm={12}>
                                            <Typography.Text strong style={{ color: '#253289' }}>Correo: </Typography.Text>
                                            <Typography.Text copyable>{record.correo || 'No especificado'}</Typography.Text>
                                        </Col>
                                        <Col xs={24} sm={12}>
                                            <Typography.Text strong style={{ color: '#253289' }}>Dirección: </Typography.Text>
                                            <Typography.Text>{record.direccion}</Typography.Text>
                                        </Col>
                                    </Row>
                                </div>
                            ),
                            rowExpandable: (record) => record.direccion !== 'Not Expandable',
                        }}
                    />
                </Card>
            </Spin>
        </div>
    );
};
export default Persona;